function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M101.333 117.333H26.6667C23.8377 117.333 21.1246 116.21 19.1242 114.209C17.1238 112.209 16 109.496 16 106.667V32.0001C16 29.1711 17.1238 26.458 19.1242 24.4576C21.1246 22.4572 23.8377 21.3334 26.6667 21.3334H37.3333V10.6667H48V21.3334H80V10.6667H90.6667V21.3334H101.333C104.162 21.3334 106.875 22.4572 108.876 24.4576C110.876 26.458 112 29.1711 112 32.0001V106.667C112 109.496 110.876 112.209 108.876 114.209C106.875 116.21 104.162 117.333 101.333 117.333ZM26.6667 53.3334V106.667H101.333V53.3334H26.6667ZM26.6667 32.0001V42.6667H101.333V32.0001H26.6667ZM58.6667 98.2081L38.896 78.4374L46.4373 70.8961L58.6667 83.1254L81.5627 60.2294L89.104 67.7707L58.6667 98.2028V98.2081Z",
  fill: "current"
});

function SvgCalendarCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCheck);
export default __webpack_public_path__ + "static/media/calendar-check.d2250f60.svg";
export { ForwardRef as ReactComponent };